import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/web/music.png'
import _imports_1 from '../../assets/web/mogaarcade.png'
import _imports_2 from '../../assets/playbutton.png'
import _imports_3 from '../../assets/web/new/lumocard.png'
import _imports_4 from '../../assets/web/new/capriccinocard.png'
import _imports_5 from '../../assets/web/new/orichicard.png'
import _imports_6 from '../../assets/web/new/goconcard.png'
import _imports_7 from '../../assets/web/new/iceviacard.png'
import _imports_8 from '../../assets/web/arrow-left.png'
import _imports_9 from '../../assets/web/arrow-right.png'
import _imports_10 from '../../assets/web/brand/brand1.png'
import _imports_11 from '../../assets/web/brand/brand2.png'
import _imports_12 from '../../assets/web/brand/brand3.png'
import _imports_13 from '../../assets/web/brand/brand4.png'
import _imports_14 from '../../assets/web/brand/brand5.png'
import _imports_15 from '../../assets/web/brand/brand6.png'
import _imports_16 from '../../assets/web/brand/brand7.png'
import _imports_17 from '../../assets/web/brand/brand8.png'
import _imports_18 from '../../assets/web/brand/brand9.png'
import _imports_19 from '../../assets/web/brand/brand10.png'
import _imports_20 from '../../assets/web/brand/brand11.png'
import _imports_21 from '../../assets/web/brand/brand12.png'
import _imports_22 from '../../assets/web/m_shop.mp3'
import _imports_23 from '../../assets/web/jonourdiscord.png'
import _imports_24 from '../../assets/web/avatar-game.png'
import _imports_25 from '../../assets/web/qq_02.png'
import _imports_26 from '../../assets/web/modal-sub.png'


const _withScopeId = n => (_pushScopeId("data-v-506c1625"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = { class: "bg2" }
const _hoisted_3 = { class: "arcade" }
const _hoisted_4 = {
  href: "https://arcade.playmonstergalaxy.com",
  target: "_blank"
}
const _hoisted_5 = { class: "bg3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "introduction" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-family":"'Jungle Adventurer'","font-size":"38px","color":"#23b4e5"} }, " Introduction "),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-family":"roboto"} }, [
    /*#__PURE__*/_createTextVNode(" The great Zodiac is misaligned and only you can set things right! Embark on an epic journey across five breathtaking lands to recover the twelve lost Zodiac relics and restore balance to the galaxy. Along the way, you’ll make new friends, complete exciting quests, and, of course, capture the captivating creatures called Moga! "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Monster Galaxy P2E is the newest entry in the hit series of monster-taming mobile games. The focus is still on the fantastic battling and taming mechanics that Monster Galaxy fans first fell in love with, but the adventure also gets a modern twist, thanks to the addition of blockchain technology. Now that each Moga is an NFT, you’ll have the chance to take real ownership of the teams you tame and to earn while you play! "),
    /*#__PURE__*/_createElementVNode("i", { style: {"color":"#a3e0f4"} }, "So, what are you waiting for, Tamer?")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-scale-101 cursor-pointer",
  src: _imports_2,
  style: {"max-width":"100%","width":"86.5px","position":"absolute","bottom":"7vh","left":"0","right":"0","margin":"auto"}
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg4" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "txtbox",
    "data-aos": "fade-up"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "t1" }, "Play For Fun"),
    /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "It’s element-ary, dear Tamer! Whether you’re making your way through the story or facing off with fellow tamers in the Arena, you’ll need a superior strategy. You’ll find out fast that the key to success lies in understanding elemental affinities and team formations. Every Moga has an elemental affinity that will determine how it interacts with both allies and opponents in battle. You’ll also have to carefully consider where on the battlefield you place your Moga, so you can be sure you’re making the most of their classes and skills. If you’re a more casual player, you can always wing it. But if you love to strategize, you and Monster Galaxy’s enhanced battle system are sure to be a winning team!")
  ])
], -1))
const _hoisted_10 = { class: "bg5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "JungleAdventurer text-4xl text-white mt-32",
  style: {"text-shadow":"0 0 10px #fff"}
}, " Play ANd Earn ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "block6 lunbo" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-slick-arrow lt-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_8 })
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-slick-arrow gt-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_9 })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 })
], -1))
const _hoisted_30 = { class: "bg6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "test0001" }, null, -1))
const _hoisted_32 = { class: "block7" }
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"bg6-title text-4xl\" data-v-506c1625>MAIN TOKENS IN MOGA UNIVERSE</div><div class=\"coinlist\" data-aos=\"fade-up\" data-v-506c1625><div class=\"coinlist-li\" data-v-506c1625></div><div class=\"coinlist-li\" data-v-506c1625></div><div class=\"coinlist-li\" data-v-506c1625></div><div class=\"coinlist-li\" data-v-506c1625></div><div class=\"coinlist-li\" data-v-506c1625></div></div>", 2)
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-slick-arrow lt-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_8 })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-slick-arrow gt-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_9 })
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coinlist-li-m m1" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coinlist-li-m m2" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coinlist-li-m m3" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coinlist-li-m m4" }, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coinlist-li-m m5" }, null, -1))
const _hoisted_42 = { class: "btn-box block lg:flex" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "buygcoin m-2 lg:mr-20 cursor-pointer h-scale-101",
  "data-aos": "fade-right",
  "aos-easing": "linear",
  "aos-duration": "1500"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"#fff"},
    href: "http://gcoin.playmonstergalaxy.com",
    target: "_blank"
  }, "BUY GCOIN")
], -1))
const _hoisted_44 = { class: "bg7" }
const _hoisted_45 = {
  "data-aos": "fade-up",
  "aos-easing": "linear",
  "aos-duration": "1500",
  action: "https://galaxygames.us8.list-manage.com/subscribe/post?u=f7527de125cde1a2c398807d0&id=d4c0c923c3&f_id=008465e0f0",
  method: "post",
  id: "mc-embedded-subscribe-form",
  name: "mc-embedded-subscribe-form",
  class: "validate text-white pt-20 pb-20 pl-20 pr-20 linkform",
  target: "_blank",
  novalidate: "",
  style: {"position":"absolute","top":"240px","border-radius":"12px","background":"rgba(22,26,52,.9)","box-shadow":"0px 8px rgba(0, 0, 0, 0.3), 0 4px #0b0e1f"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title text-6xl",
  style: {"font-family":"'Jungle Adventurer"}
}, "Don't miss out!", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle mt-10" }, [
  /*#__PURE__*/_createTextVNode("Ready to be part of our journey? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Sign up to receive the latest updates, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" giveaways, events and more! ")
], -1))
const _hoisted_48 = { class: "line mt10" }
const _hoisted_49 = { class: "flex justify-center" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "mce-responses",
  class: "clear mt10"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "response",
    id: "mce-error-response",
    style: {"display":"none"}
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "response",
    id: "mce-success-response",
    style: {"display":"none"}
  })
], -1))
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"bg8\" data-v-506c1625><div class=\"bl8inner\" data-v-506c1625><div style=\"flex-wrap:wrap;\" data-v-506c1625><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_10 + "\" class=\"br1\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_11 + "\" class=\"br2\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_12 + "\" class=\"br3\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_13 + "\" class=\"br4\" alt=\"\" data-v-506c1625></a></div><div data-v-506c1625><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_14 + "\" class=\"br5\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_15 + "\" class=\"br6\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_16 + "\" class=\"br7\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_17 + "\" class=\"br8\" alt=\"\" data-v-506c1625></a></div><div style=\"flex-wrap:wrap;display:flex;\" data-v-506c1625><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_18 + "\" class=\"br9 img-fluid\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_19 + "\" class=\"br10 img-fluid\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_20 + "\" class=\"br11 img-fluid\" alt=\"\" data-v-506c1625></a><a class=\"partner-item\" href=\"#\" data-v-506c1625><img src=\"" + _imports_21 + "\" class=\"br12 img-fluid\" alt=\"\" data-v-506c1625></a></div></div></div>", 1)
const _hoisted_52 = {
  key: 0,
  id: "audio",
  ref: "audio",
  class: "aud",
  loop: "",
  autoplay: ""
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", { src: _imports_22 }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "draggable-container",
  href: "https://discord.com/invite/TtGeWffXTg",
  target: "_blank",
  style: {"position":"fixed","bottom":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_23
  })
], -1))
const _hoisted_56 = { ref: "replyModal" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "avatar",
    style: {"width":"140px","height":"140px","margin":"0 auto 5px","background":"#D9D9D9","box-shadow":"0 0 4px #CDFFF7, 0 0 20px #16D5FF","border-radius":"20px","overflow":"hidden"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_24,
      alt: "",
      class: "avatar"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text1",
    style: {"font-size":"24px","color":"#FFFFFF","text-shadow":"0 0 4px #CDFFF7, 0 0 20px #16D5FF","text-align":"center"}
  }, [
    /*#__PURE__*/_createTextVNode("Download"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Monster Galaxy P2E!")
  ]),
  /*#__PURE__*/_createElementVNode("ul", { class: "my-4 space-y-3 mt-10" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://rebrand.ly/MonsterGalaxyAppStore",
        target: "_blank",
        class: "flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          "aria-hidden": "true",
          class: "h-5",
          viewBox: "0 0 292 292",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            d: "M145.7 291.66C226.146 291.66 291.36 226.446 291.36 146C291.36 65.5541 226.146 0.339844 145.7 0.339844C65.2542 0.339844 0.0400391 65.5541 0.0400391 146C0.0400391 226.446 65.2542 291.66 145.7 291.66Z",
            fill: "#3259A5"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M195.94 155.5C191.49 179.08 170.8 196.91 145.93 196.91C117.81 196.91 95.0204 174.12 95.0204 146C95.0204 117.88 117.81 95.0897 145.93 95.0897C170.8 95.0897 191.49 112.93 195.94 136.5H247.31C242.52 84.7197 198.96 44.1797 145.93 44.1797C89.6904 44.1797 44.1104 89.7697 44.1104 146C44.1104 202.24 89.7004 247.82 145.93 247.82C198.96 247.82 242.52 207.28 247.31 155.5H195.94Z",
            fill: "white"
          })
        ]),
        /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "APP STORE"),
        /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded dark:bg-gray-700 dark:text-gray-400" }, "Popular")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://rebrand.ly/MonsterGalaxyGooglePlay",
        target: "_blank",
        class: "flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          "aria-hidden": "true",
          class: "h-5",
          viewBox: "0 0 292 292",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            d: "M145.7 291.66C226.146 291.66 291.36 226.446 291.36 146C291.36 65.5541 226.146 0.339844 145.7 0.339844C65.2542 0.339844 0.0400391 65.5541 0.0400391 146C0.0400391 226.446 65.2542 291.66 145.7 291.66Z",
            fill: "#3259A5"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M195.94 155.5C191.49 179.08 170.8 196.91 145.93 196.91C117.81 196.91 95.0204 174.12 95.0204 146C95.0204 117.88 117.81 95.0897 145.93 95.0897C170.8 95.0897 191.49 112.93 195.94 136.5H247.31C242.52 84.7197 198.96 44.1797 145.93 44.1797C89.6904 44.1797 44.1104 89.7697 44.1104 146C44.1104 202.24 89.7004 247.82 145.93 247.82C198.96 247.82 242.52 207.28 247.31 155.5H195.94Z",
            fill: "white"
          })
        ]),
        /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "GOOGLE PLAY")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://rebrand.ly/MonsterGalaxyAPK",
        target: "_blank",
        class: "flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          "aria-hidden": "true",
          class: "h-4",
          viewBox: "0 0 96 96",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            d: "M72.0998 0.600098H48.3998H24.5998H0.799805V24.4001V48.2001V49.7001V71.8001V71.9001V95.5001H24.5998V72.0001V71.9001V49.8001V48.3001V24.5001H48.3998H72.1998H95.9998V0.700104H72.0998V0.600098Z",
            fill: "#617BFF"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M48.5 71.8002H72.1V95.6002H73C79.1 95.6002 84.9 93.2002 89.2 88.9002C93.5 84.6002 95.9 78.8002 95.9 72.7002V48.2002H48.5V71.8002Z",
            fill: "#617BFF"
          })
        ]),
        /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "APK")
      ])
    ])
  ])
], -1))
const _hoisted_61 = { ref: "buyggmModal" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "avatar",
    style: {"width":"140px","height":"140px","margin":"0 auto 5px","background":"#D9D9D9","box-shadow":"0 0 4px #CDFFF7, 0 0 20px #16D5FF","border-radius":"20px","overflow":"hidden"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_24,
      alt: "",
      class: "avatar"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text1",
    style: {"font-size":"24px","color":"#FFFFFF","text-shadow":"0 0 4px #CDFFF7, 0 0 20px #16D5FF","text-align":"center"}
  }, "Monster Galaxy P2E!"),
  /*#__PURE__*/_createElementVNode("ul", { class: "my-4 space-y-3 mt-10" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.gate.io/zh/trade/GGM_USDT",
        target: "_blank",
        class: "flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "BUY GGM ON GATE.IO")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.bybit.com/en-US/trade/spot/GGM/USDT",
        target: "_blank",
        class: "flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "BUY GGM ON BYBIT")
      ])
    ])
  ])
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = {
  key: 0,
  class: "wrapper-video ratio ratio-16x9",
  style: {"margin":"0 auto","margin-top":"15px"}
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
  style: {"width":"100%","height":"100%"},
  src: "https://www.youtube.com/embed/rG8oNtt9BeE?autoplay=1",
  title: "YouTube video"
}, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 1,
  class: "dingyue-pop",
  style: {"position":"fixed","top":"0","bottom":"0","left":"0","right":"0","display":"flex","align-items":"center","justify-content":"center","z-index":"999"}
}
const _hoisted_73 = {
  class: "dingyue-bg",
  style: {"position":"relative"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "567",
  src: _imports_25
}, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "567",
    src: _imports_26
  })
], -1))
const _hoisted_76 = [
  _hoisted_75
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "play-btn animate-bounce cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, " play "),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            style: {"position":"fixed","z-index":"3","top":"90px","right":"0"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePlayMusic && _ctx.handlePlayMusic(...args))),
            class: "mr-11",
            width: "41",
            src: _imports_0
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("img", {
              style: {"position":"fixed","z-index":"3","top":"150px","right":"0"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePlayMusic && _ctx.handlePlayMusic(...args))),
              class: "mr-11",
              width: "150",
              src: _imports_1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: "playvideo-btn",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showvideomodal && _ctx.showvideomodal(...args)))
        }, _hoisted_8)
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", {
          class: "monster-list",
          "data-aos": "fade-up",
          onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.jhl && _ctx.jhl(...args)))
        }, [
          _createElementVNode("div", {
            class: "jh",
            onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.jh(0)))
          }, _hoisted_13, 32),
          _createElementVNode("div", {
            class: "jh",
            onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.jh(1)))
          }, _hoisted_15, 32),
          _createElementVNode("div", {
            class: "jh",
            id: "jh",
            onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.jh(2)))
          }, _hoisted_17, 32),
          _createElementVNode("div", {
            class: "jh",
            onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.jh(3)))
          }, _hoisted_19, 32),
          _createElementVNode("div", {
            class: "jh",
            onMouseenter: _cache[8] || (_cache[8] = ($event: any) => (_ctx.jh(4)))
          }, _hoisted_21, 32)
        ], 32),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_a_carousel, {
            type: "card",
            dots: false,
            arrows: ""
          }, {
            prevArrow: _withCtx(() => [
              _hoisted_23
            ]),
            nextArrow: _withCtx(() => [
              _hoisted_24
            ]),
            default: _withCtx(() => [
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode(_component_a_carousel, {
            class: "coinbi-card",
            type: "card",
            dots: false,
            arrows: ""
          }, {
            prevArrow: _withCtx(() => [
              _hoisted_35
            ]),
            nextArrow: _withCtx(() => [
              _hoisted_36
            ]),
            default: _withCtx(() => [
              _hoisted_37,
              _hoisted_38,
              _hoisted_39,
              _hoisted_40,
              _hoisted_41
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", {
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.ggmvisiblehandleOk && _ctx.ggmvisiblehandleOk(...args))),
              class: "m-2 buyggm cursor-pointer h-scale-101",
              "data-aos": "fade-right"
            }, "BUY GGM")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("form", _hoisted_45, [
          _hoisted_46,
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              name: "email",
              id: "email",
              class: "mt-20 mb-10 mb-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white",
              placeholder: "Enter your email address",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.subscribeEmail && _ctx.subscribeEmail(...args))),
                style: {"background":"#ffbc4b","font-family":"'Jungle Adventurer'","font-size":"20px","box-shadow":"0px 8px rgba(0, 0, 0, 0.3), 0 4px #cb5700"},
                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              }, "SUBSCRIBE")
            ])
          ]),
          _hoisted_50
        ])
      ]),
      _hoisted_51
    ]),
    (_ctx.musicSrc)
      ? (_openBlock(), _createElementBlock("audio", _hoisted_52, _hoisted_54, 512))
      : _createCommentVNode("", true),
    _hoisted_55,
    _createElementVNode("div", _hoisted_56, [
      _createVNode(_component_a_modal, {
        class: "play-modal",
        closable: false,
        visible: _ctx.visible,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.visible) = $event)),
        title: "",
        footer: null,
        style: {"padding-bottom":"0","background":"#0A0048","overflow":"hidden","border-radius":"12px"},
        "dialog-style": "background: #0A0048",
        "body-style": "background: #0A0048"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
            type: "button",
            class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white",
            "data-modal-hide": "crypto-modal"
          }, _hoisted_59),
          _hoisted_60
        ]),
        _: 1
      }, 8, ["visible"])
    ], 512),
    _createElementVNode("div", _hoisted_61, [
      _createVNode(_component_a_modal, {
        class: "buyggm-modal",
        closable: false,
        visible: _ctx.ggmvisible,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ggmvisible) = $event)),
        title: "",
        footer: null,
        style: {"padding-bottom":"0","background":"#0A0048","overflow":"hidden","border-radius":"12px"},
        "dialog-style": "background: #0A0048",
        "body-style": "background: #0A0048"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.ggmvisiblehandleClose && _ctx.ggmvisiblehandleClose(...args))),
            type: "button",
            class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white",
            "data-modal-hide": "crypto-modal"
          }, _hoisted_64),
          _hoisted_65
        ]),
        _: 1
      }, 8, ["visible"])
    ], 512),
    _createVNode(_component_a_modal, {
      id: "videoModal",
      class: "video-modal",
      closable: false,
      visible: _ctx.videoVisible,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.videoVisible) = $event)),
      title: "",
      footer: null,
      style: {"width":"950px","background":"transparent","overflow":"hidden","border-radius":"12px","padding-bottom":"0"},
      "dialog-style": "background: transparent",
      "body-style": "background: #1B203E"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.showvideomodal && _ctx.showvideomodal(...args))),
          type: "button",
          class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white",
          "data-modal-hide": "crypto-modal"
        }, _hoisted_68),
        (_ctx.videoVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.isSubscription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("div", {
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.closeSubscription && _ctx.closeSubscription(...args))),
              class: "close",
              style: {"position":"absolute","right":"10px","width":"10%","height":"10%","top":"10px"}
            }),
            _withDirectives(_createElementVNode("input", {
              style: {"position":"absolute","top":"64%","background-color":"rgba(0,0,0,.68)","border":"none","left":"0","right":"0","margin":"auto"},
              type: "email",
              size: "mini",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.email) = $event)),
              name: "email",
              id: "email",
              class: "roboto mt-20 bg-gray-50 border border-gray-300 text-xl rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-2/3 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 text-white",
              placeholder: "YOUR EMAIL ADDRESS",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _createElementVNode("div", {
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.subscribeEmail && _ctx.subscribeEmail(...args))),
              class: "dingyue mt-10",
              style: {"position":"absolute","width":"60%","height":"20%","bottom":"0","left":"0","right":"0","margin":"auto"}
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.issucesss)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handissucesss && _ctx.handissucesss(...args))),
          style: {"position":"fixed","top":"0","bottom":"0","left":"0","right":"0","background":"rgba(0,0,0,.7)","display":"flex","align-items":"center","justify-content":"center","z-index":"999"}
        }, _hoisted_76))
      : _createCommentVNode("", true)
  ], 64))
}